import React from 'react';

import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Link Out Stroke v2
 */

export default function LinkOutV2StrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path
          clipRule="evenodd"
          d="M2.66667 2.66672H8.88889C9.54692 2.66672 10.1214 3.02423 10.4288 3.55561H11.4038C11.0377 2.51988 10.05 1.77783 8.88889 1.77783H2.66667C1.19391 1.77783 0 2.97174 0 4.4445V11.5556C0 13.0284 1.19391 14.2223 2.66667 14.2223H8.88889C10.3616 14.2223 11.5556 13.0284 11.5556 11.5556H10.6667C10.6667 12.5375 9.87073 13.3334 8.88889 13.3334H2.66667C1.68483 13.3334 0.888889 12.5374 0.888889 11.5556V4.4445C0.888889 3.46266 1.68483 2.66672 2.66667 2.66672Z"
          fill="#009B00"
          fillRule="evenodd"
        />
        <path
          d="M12.4443 4.44446L15.111 7.11112L12.4443 9.77779"
          stroke="#009B00"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.888889"
        />
        <path
          d="M15.1115 7.11108H8.88932C7.41656 7.11108 6.22266 8.30499 6.22266 9.77775V10.6666"
          stroke="#009B00"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.888889"
        />
      </svg>
    </Icon>
  );
}
